// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__OoRsg","spin":"styles_spin__zPb9j"};